<section class="hero" [ngStyle]="{'background-image': 'url(' + data_hero.image.url + ')'}">
    <!-- <img [src]="data_hero.image.url" [alt]="data_hero.image.alt"> -->
    <div class="hero-txt">
        <h2>{{data_aiuppie.name}}</h2>
        <h3>{{data_aiuppie.description}}</h3>
    </div>
</section>
